import {
  deleteFromLocalStorage,
  getFromLocalStorage,
  setToLocalStorage,
} from "@/utils/local-storage.util";
import { LOGIN_MUTATION } from "@/graphql/mutations/login.mutation";
import { handleGqlResponseBody } from "@/utils/apollo.util";
import { LOGOUT_MUTATION } from "@/graphql/mutations/logout.mutation";
import { RESET_USER_PASSWORD_MUTATION } from "@/graphql/mutations/reset-user-password.mutation";
import { CHECK_RESET_USER_PASSWORD_TOKEN_MUTATION } from "@/graphql/mutations/check-reset-user-password-token.mutation";
import { CONFIRM_RESET_USER_PASSWORD_MUTATION } from "@/graphql/mutations/confirm-reset-user-password.mutation";


export let USER_PRIVILEGES = null;
export const changeUserPrivileges = (userRoles) => {
  USER_PRIVILEGES = userRoles
}

export const clearLoginData = () => {
  deleteFromLocalStorage("accessToken");
  deleteFromLocalStorage("refreshToken");
  deleteFromLocalStorage("user");
};

const authentication = {
  state: {
    accessToken: getFromLocalStorage("accessToken"),
    refreshToken: getFromLocalStorage("refreshToken"),
  },
  mutations: {
    setAccessAndRefreshTokens(state, { accessToken, refreshToken }) {
      state.accessToken = setToLocalStorage("accessToken", accessToken);
      state.refreshToken = setToLocalStorage("refreshToken", refreshToken);
    },
    logOut() {
      this.commit("clearCurrentUser");
      clearLoginData();
    },
  },
  actions: {
    async changeUser({ commit }, loginResponse) {
      const userData = loginResponse.user
      userData.userGroup.privileges = userData.userGroup.privileges.reduce((acc, curr) => {
        acc[curr.alt] = true
        return acc
      }, {})
      
      commit("setCurrentUser", loginResponse.user);
      commit("setAccessAndRefreshTokens", {
        accessToken: loginResponse.accessToken,
        refreshToken: loginResponse.refreshToken,
      });
      
      changeUserPrivileges(userData.userGroup.privileges)
    },
    async loginUser({ dispatch }, credentials) {
      const loginResponse = await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: LOGIN_MUTATION,
          variables: credentials,
        });
      });
      
      dispatch("changeUser", loginResponse);
    },
    async logoutUser({ commit, state }) {
      await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: LOGOUT_MUTATION,
          variables: {
            refreshToken: state.refreshToken ?? "",
          },
        });
      });

      commit("logOut");
    },
    async resetUserPassword({ commit, state }, { email }) {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: RESET_USER_PASSWORD_MUTATION,
          variables: { email },
        });
      });
    },
    async checkResetUserPasswordToken({ commit, state }, { token, code }) {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: CHECK_RESET_USER_PASSWORD_TOKEN_MUTATION,
          variables: { token, code },
        });
      });
    },
    async confirmResetUserPassword(
      { commit, state },
      { token, code, password }
    ) {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: CONFIRM_RESET_USER_PASSWORD_MUTATION,
          variables: { token, code, password },
        });
      });
    },
  },
};

export default authentication;
